<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="leftLine"></span>
        <el-breadcrumb-item>首页</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-refresh"
                 size="mini"
                 @click="handleClick">刷新</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <div class="tjBox">
            <p>签约用户统计</p>
            <div class="ax_default line"></div>
            <el-row style="display:flex;justify-content: space-between;">
              <el-col :span="8"
                      class="item">
                <div class="imgBox"
                     style="background:rgb(45,183,245)">
                  <img src="../../assets/u175.png">
                </div>

                <div>
                  <span>客户总数（个）</span><br>
                  <span style="font-size:28px">{{totalClient}}</span>
                </div>
              </el-col>
              <el-col :span="8"
                      class="item">
                <div class="imgBox"
                     style="background:rgb(125,200,86)">
                  <img src="../../assets/u185.png">
                </div>

                <div>
                  <span>已签约（个）</span><br>
                  <span style="font-size:28px">{{signedNumber}}</span>
                </div>
              </el-col>
              <el-col :span="8"
                      class="item">
                <div class="imgBox"
                     style="background:rgb(128,139,198)">
                  <img src="../../assets/u180.png">
                </div>

                <div>
                  <span>已绑定（个）</span><br>
                  <span style="font-size:28px">{{bound}}</span>
                </div>
              </el-col>
              <el-col :span="8"
                      class="item">
                <div class="imgBox"
                     style="background:rgb(249,191,0)">
                  <img src="../../assets/u190.png">
                </div>

                <div>
                  <span>未绑定（个）</span><br>
                  <span style="font-size:28px">{{unbound}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"
                style="margin-top:20px">
          <div class="tjBox">
            <el-table ref="multipleTable"
                      :data="tableData"
                      tooltip-effect="dark"
                      style="width: 100%">
              <el-table-column prop="province"
                               label="省份">
              </el-table-column>
              <el-table-column label="年度交易电量">
                <template slot-scope="scope">{{ scope.row.annualTransactionPower }}</template>
              </el-table-column>
              <el-table-column prop="monthTransactionPower"
                               label="本月交易电量">
              </el-table-column>
              <!-- <el-table-column prop="customerPrincipleNumber"
                               label="联系方式">
              </el-table-column>
              <el-table-column prop="name"
                               label="类别">
              </el-table-column> -->

              <!-- <el-table-column prop="address"
                               label="操作"
                               show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row)"
                             type="text"
                             size="small">修改</el-button>
                  <el-button type="text"
                             size="small"
                             @click="deleteTable(scope.$index, tableData)">删除</el-button>

                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </el-col>
      </el-row>
      <div>
      </div>
    </div>
  </div>
</template>
<script>
import { getmonthlyStatistics,getunsignedClientManager,getpower } from '../../API'
export default {
  inject: ['reload'],
  data () {
    return {
      activeIndex: this.$route.path,
      newClientNumber: 0,
      signedNumber: 0,
      totalClient: 0,
      unsignedNumber: 0,
      tableData:[],
      bound:0,
      unbound:0,
      formInline: {
        user: '',
        region: ''
      }
    }
  },
  created () {
    getmonthlyStatistics().then(res => {
      if (res.code === 0) {
        this.totalClient = res.data.totalClient.toLocaleString()
        this.unbound = res.data.unbound?res.data.unbound.toLocaleString():0
        this.signedNumber = res.data.signedNumber.toLocaleString()
        this.bound = res.data.bound?res.data.bound.toLocaleString():0
      }
    })
    getpower().then(res=>{
      if(res.code===0){
        this.tableData = res.data
      }
    })
  },
  methods: {
    //在需要执行的事件之后执行reload
    handleClick () {
      this.reload()
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid rgba(235, 235, 235, 1);
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
.tjBox {
  background: #fff;
  border: 1px solid rgba(235, 235, 235, 1);
  p {
    padding: 20px;
  }
  .item {
    display: flex;
    padding: 30px;
    justify-content: space-between;
    width: 280px;
  }
  .imgBox {
    width: 56px;
    height: 56px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>